module.exports = {
  "listOptions": {},
  "api": {},
  "project": {}
}



//////////////////
// WEBPACK FOOTER
// ./config/@sanity/data-aspects.json?sanityPart=config%3A%40sanity%2Fdata-aspects
// module id = 2094
// module chunks = 0